// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"757":"d1e699b2645d74bfc43f","1883":"62f889303b710cbf5eb7"}[chunkId] + ".css";
};